import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledColorPicker = styled.div`
  .color-picker-container.picker-shown {
    transition: 0.25s;
    transition-timing-function: ease-out;
    transform: translateY(0);
    opacity: 1;
    z-index: 2;
  }

  .color-picker-container {
    opacity: 0;
    max-height: 100%;
    width: 2em;
    padding: 0.5em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: 0;
    cursor: pointer;
    z-index: -1;

    transform: translateY(20%);
    transition-timing-function: ease-in;
    transition: 0.2s;

    span {
      height: 1.5em;
      width: 1.5em;
      border-radius: 50%;
      margin-bottom: 0.3em;
    }
  }
`;

const SignatureColorPicker = ({ open, clickHandler }) => {
  const pickerColors = [
    'white',
    'blue',
    'green',
    'yellow',
    'orange',
    'red',
    'black',
  ];

  return (
    <StyledColorPicker>
      <div
        className={`${
          open
            ? 'color-picker-container picker-shown'
            : 'color-picker-container'
        }`}
      >
        {pickerColors.map((color) => {
          const selectedColor = { activeColor: color, openColor: false };
          return (
            // eslint-disable-next-line jsx-a11y/control-has-associated-label
            <span
              key={color}
              style={{ backgroundColor: color, border: '1px solid grey' }}
              onClick={() => clickHandler(selectedColor)}
              onKeyDown={() => clickHandler(selectedColor)}
              role="button"
              tabIndex={0}
              title={color}
            />
          );
        })}
      </div>
    </StyledColorPicker>
  );
};

SignatureColorPicker.propTypes = {
  open: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func.isRequired,
};

export default React.memo(SignatureColorPicker);
